import React from "react";
import { Eyebrow, Cta } from "../../components/site/kit";
import { ConvergeField, Reveal } from "../../components/site/motion";
import { CAPABILITIES } from "../../lib/content";

export const Capabilities = () => (
  <section data-testid="home-capabilities" className="border-b border-black/10 bg-[#F7F6F2]">
    <div className="mx-auto max-w-[1360px] px-6 py-24 md:px-12 md:py-32 lg:px-16">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
          <Eyebrow>Collective expertise</Eyebrow>
          <h2 className="font-display mt-6 text-4xl leading-[0.95] tracking-tight text-black md:text-5xl lg:text-6xl">
            Every discipline that moves growth, <span className="text-[#5f8f10]">in one room.</span>
          </h2>
          <p className="font-body mt-6 max-w-md text-lg font-normal leading-relaxed text-black/80">
            We do not specialise in one lever. The problem decides which disciplines come together around a single growth agenda, so nothing that matters gets left out.
          </p>
          <div className="mt-8 overflow-hidden border border-black/15 bg-[#161A15] p-6">
            <div className="mx-auto aspect-[16/11] w-full max-w-[440px]">
              <ConvergeField />
            </div>
          </div>
          <Cta to="/how-we-work" testId="home-capabilities-cta" className="mt-8">Learn more</Cta>
        </div>
        <div className="lg:col-span-7">
          <div className="border-t border-black/15">
            {CAPABILITIES.map((c, i) => (
              <Reveal key={c.title} delay={(i % 4) * 0.08} className="group -mx-3 rounded-md border-b border-black/15 px-3 py-6 transition-colors duration-200 hover:bg-black/[0.03]">
                <div className="flex items-baseline gap-6">
                  <span className="font-display w-14 shrink-0 text-4xl leading-none text-[#5f8f10] md:text-5xl">0{i + 1}</span>
                  <h3 className="font-display text-xl uppercase leading-[1.05] tracking-tight text-black transition-colors duration-200 group-hover:text-[#5f8f10] md:text-2xl">{c.title}</h3>
                </div>
                <p className="font-body mt-2 pl-20 text-base font-normal leading-relaxed text-black/60">{c.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);

